module.exports = __webpack_public_path__ + "static/media/user-icon.e9947fca.png";